<template>
  <el-container>

    <el-container>

      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script type="text/javascript">
import tabList from "../tabList.vue";
export default {
  components: { tabList },
  data() {
    return {
      Token: "",
    };
  },
  created() {},
  methods: {
    goQuestion() {
      this.$router.push("/Container/question");
    },
    goHome() {
      this.$router.push("/Container/home");
    },
  },
};
</script>

<style>
@import url("container.css");
</style>


// WEBPACK FOOTER //
// src/components/container/container.vue